import { useState, useEffect } from 'react';

export function useIsMobile(breakpoint = 768): boolean {
    const getIsMobile = () => {
        if (typeof window === 'undefined') return false;
        // Use the smaller screen dimension so landscape orientation doesn't flip isMobile to false
        const smallerDim = Math.min(window.screen.width, window.screen.height);
        return smallerDim < breakpoint;
    };
    const [isMobile, setIsMobile] = useState(getIsMobile);
    useEffect(() => {
        const handler = () => setIsMobile(getIsMobile());
        window.addEventListener('resize', handler);
        window.addEventListener('orientationchange', handler);
        return () => {
            window.removeEventListener('resize', handler);
            window.removeEventListener('orientationchange', handler);
        };
    }, [breakpoint]);
    return isMobile;
}
